import { Button, Form, Input } from "antd";
import React, { useContext, useState } from "react";
import { CloseOutlined, EditOutlined } from "@ant-design/icons";
import { updateExpert } from "../../../../service/api";
import ExpertDataContext from "../../../../context/expertDataContext";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import ResumeUploader from "../../../../components/CustomUpload/ResumeUploader";

function Resume(data) {
  const { resume, expertDataQuery } = data?.data;

  const queryClient = useQueryClient();
  const { expertDataAction, expertData, resetExpertDataContext } =
    useContext(ExpertDataContext);
  const [showBtn, setShowBtn] = useState(false);
  const [loading, setLoading] = useState();

  const mutation = useMutation(updateExpert, {
    onMutate: () => {
      setLoading(true);
    },
    onError: () => {
      setLoading(false);
    },
    onSuccess: () => {
      resetExpertDataContext();
      setShowBtn(false);
      setLoading(false);
      queryClient.invalidateQueries(["expertData"]);
    },
  });

  let modifiedExpert = expertDataQuery?.data?.modifiedExpert;
  let expert = expertDataQuery?.data?.expert;
  const onSubmit = () => {
    mutation.mutate(expertData);
  };

  const handleChange = (e) => {
    expertDataAction(e?.target?.name, e?.target?.value);
  };

  return (
    <div className="bg-white p-3 rounded-xl">
      <header className="text-[#005AC8] font-body text-right pb-6 text-[1.625rem] font-bold">
        رزومه علمی کارشناس
      </header>
      <Form
        onChange={() => setShowBtn(true)}
        className="flex flex-row gap-20 max-lg:flex-col "
      >
        <section className="flex w-[50vw] flex-col  max-lg:w-full ">
          <Form.Item
            labelAlign="right"
            label="لینک googleScholar "
            className="w-full text-left"
          >
            <Input
              allowClear={true}
              className="w-[25vw]  max-lg:mr-0 text-xs"
              name="googleScholarURL"
              onChange={handleChange}
              defaultValue={
                modifiedExpert?.googleScholarURL &&
                modifiedExpert?.googleScholarURL !== "NOT_MODIFIED"
                  ? modifiedExpert?.googleScholarURL
                  : expert?.googleScholarURL
              }
            />
          </Form.Item>
          <Form.Item
            labelAlign="right"
            label="لینک researchGate"
            className=" w-full text-left"
          >
            <Input
              allowClear={true}
              className="w-[25vw]  max-lg:mr-0 text-xs"
              name="researchGateURL"
              onChange={handleChange}
              defaultValue={
                modifiedExpert?.researchGateURL &&
                modifiedExpert?.researchGateURL !== "NOT_MODIFIED"
                  ? modifiedExpert?.researchGateURL
                  : expert?.researchGateURL
              }
            />
          </Form.Item>
          <Form.Item
            labelAlign="right"
            label="لینک دلخواه"
            className=" w-full text-left"
          >
            <Input
              allowClear={true}
              className="w-[25vw]  max-lg:mr-0 text-xs"
              name="otherSocialNetworkURL"
              onChange={handleChange}
              defaultValue={
                modifiedExpert?.otherSocialNetworkURL &&
                modifiedExpert?.otherSocialNetworkURL !== "NOT_MODIFIED"
                  ? modifiedExpert?.otherSocialNetworkURL
                  : expert?.otherSocialNetworkURL
              }
            />
          </Form.Item>
        </section>
        <section className="   w-1/2 max-lg:w-full">
          <Form.Item label="آپلود رزومه">
            <ResumeUploader />
            {modifiedExpert & (modifiedExpert?.resume === "NOT_MODIFIED") ||
            expert & expert?.resume ? (
              <a
                href={
                  modifiedExpert && modifiedExpert?.resume === "NOT_MODIFIED"
                    ? process.env.REACT_APP_ARVAN_S3_BASE_URL + resume
                    : process.env.REACT_APP_ARVAN_S3_BASE_URL +
                      modifiedExpert?.resume
                }
              >
                مشاهده
              </a>
            ) : null}
          </Form.Item>
        </section>
      </Form>
      {showBtn ? (
        <div className=" flex flex-row justify-end gap-8">
          <Button
            onClick={() => setShowBtn(false)}
            icon={<CloseOutlined />}
            danger={true}
          >
            لغو
          </Button>
          <Button loading={loading} onClick={onSubmit} icon={<EditOutlined />}>
            اعمال تغییر
          </Button>
        </div>
      ) : null}
    </div>
  );
}

export default Resume;
